module.exports = __webpack_public_path__ + "static/media/Barranca_256x256px.ee848ef6.jpg";